import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderState } from '../loader-state';
import { LoaderService } from '../loader.service';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationCancel } from '@angular/router';

@Component({
  selector: 'pv-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;

  private subscription: Subscription

  constructor(
    private loaderService: LoaderService,
    private router: Router
  ) { }

  ngOnInit() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.loaderService.show()
        } else if (
          event instanceof RouteConfigLoadEnd ||
          event instanceof NavigationCancel
        ) {
          this.loaderService.hide()
        }
      })



    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
